import { render, staticRenderFns } from "./FundraisingGoalCard.vue?vue&type=template&id=5960e46c&scoped=true&"
import script from "./FundraisingGoalCard.vue?vue&type=script&lang=ts&"
export * from "./FundraisingGoalCard.vue?vue&type=script&lang=ts&"
import style0 from "./FundraisingGoalCard.vue?vue&type=style&index=0&id=5960e46c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5960e46c",
  null
  
)

export default component.exports